import { useMemo } from 'react';
import { SiPytorch, SiTensorflow } from 'react-icons/si';
import { styled } from 'styled-components';
import { ProjectSummary } from 'types';
import { calcTimeGapToNowInKorean } from 'utils/commonUtils';

const FRAMEWORK = {
  PyTorch: {
    color: '#E6492A',
    Icon: SiPytorch,
  },
  TensorFlow: {
    color: '#F68200',
    Icon: SiTensorflow,
  },
} as Record<string, { color: string; Icon: any }>;

const InfoLayout = styled.div`
  padding: 10px 14px;
  display: flex;
  align-items: center;
`;

const Framework = styled.div<{ $color: string }>`
  min-width: 36px;
  display: flex;
  justify-content: flex-start;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  span {
    color: ${(props) => props.$color};
    font-size: 10px;
    font-weight: 500;
  }

  svg {
    color: ${(props) => props.$color};
    font-size: 24px;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 36px);
`;

const ProjectName = styled.span`
  width: 100%;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
`;

const UpdatedAt = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.global.lightTextColor};
`;

interface ProjectCardInfoProps {
  project: ProjectSummary;
}

const ProjectCardInfo = ({ project }: ProjectCardInfoProps) => {
  const FrameworkIcon = FRAMEWORK[project.framework].Icon;
  const timeGap = useMemo(() => calcTimeGapToNowInKorean(new Date(project.updateDate)), [project.updateDate]);

  return (
    <InfoLayout>
      <Framework $color={FRAMEWORK[project.framework].color}>
        <div>
          <FrameworkIcon />
          <span>{project.frameworkVersion}</span>
        </div>
      </Framework>
      <Info>
        <ProjectName>{project.projectName}</ProjectName>
        <UpdatedAt>{timeGap}</UpdatedAt>
      </Info>
    </InfoLayout>
  );
};

export default ProjectCardInfo;
